/**
 * Detects whether a User.displayName looks like the BE-seeded auto-name
 * given to fresh email registrations — `"Гость XXXX"` where XXXX is the
 * first four hex characters of the user id, uppercase. Also true for the
 * pre-seed legacy values `null`, `''`, and `"User"` (the generic backend
 * `ChatDisplayNameFactory.GenericFallback`).
 *
 * Used by the onboarding modal gate to decide whether the user still
 * needs to introduce themselves before interacting with the rest of the
 * app. See [src/utils/safeDisplayName.ts](./safeDisplayName.ts) for the
 * sibling helper that produces the friendly fallback in chat surfaces.
 */
export function isAutoGeneratedDisplayName(
  displayName: string | null | undefined,
): boolean {
  const trimmed = (displayName ?? '').trim();
  if (trimmed === '' || trimmed === 'User') return true;
  return /^Гость [A-F0-9]{4}$/.test(trimmed);
}
